module.exports = __webpack_public_path__ + "img/board.863b7520.svg";